import urls from "global/constants/UrlConstants";
import {
  getCallParams,
  getFileCallParams,
  getSearchedCallParams,
  makeCall,
} from "utils/service";

export const fetchGroupCount = async (
  contactType: string,
  searchText: string
) => {
  const body = {
    searchText: searchText,
    filterType: contactType,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_GROUPS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchGroups = async (
  page: number,
  rowsPerPage: number,
  contactType: string,
  searchText: string
) => {
  const url = `${urls.GET_ALL_GROUPS}/page/${page}/limit/${rowsPerPage}/new`;
  const body = {
    searchText: searchText,
    filterType: contactType,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const searchGroupsCount = async (
  contactType: string,
  searchText: string
) => {
  const url = `${urls.SEARCH_GROUPS_COUNT}/count/type/${contactType}/new`;
  try {
    const callParams = await getSearchedCallParams("POST", searchText);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const searchGroups = async (
  page: number,
  rowsPerPage: number,
  contactType: string,
  searchText: string
) => {
  const url = `${urls.SEARCH_GROUPS}/type/${contactType}/page/${page}/limit/${rowsPerPage}/new`;
  try {
    const callParams = await getSearchedCallParams("POST", searchText);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactGroupCount = async (groupId: string) => {
  const url = `${urls.CONTACT_GROUP_COUNT}/${groupId}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactGroup = async (
  groupId: string,
  page: number,
  rowsPerPage: number
) => {
  const url = `${urls.GET_ALL_GROUPS}/${groupId}/page/${page}/limit/${rowsPerPage}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const searchContactGroupCount = async (
  groupId: string,
  searchText: string
) => {
  const url = `${urls.CONTACT_SEARCH_GROUP_COUNT}/${groupId}/new`;
  try {
    const callParams = await getSearchedCallParams("POST", searchText);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const searchContactGroup = async (
  page: number,
  rowsPerPage: number,
  groupId: string,
  searchText: string
) => {
  const url = `${urls.SEARCH_GROUPS}/${groupId}/page/${page}/limit/${rowsPerPage}/new`;
  try {
    const callParams = await getSearchedCallParams("POST", searchText);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const exportGroup = async (groupId: string) => {
  const url = `${urls.EXPORT_GROUPS}/${groupId}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteContactGroup = async (groupId: any) => {
  try {
    const callParams = await getCallParams("DELETE");
    const url = `${urls.DELETE_CONTACT_GROUP}/group/${groupId}/new`;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteContactSingleGroup = async (
  contactId: any,
  groupId: any
) => {
  try {
    const callParams = await getCallParams("DELETE");
    const url = `${urls.DELETE_CONTACT_GROUP}/contactId/${contactId}/groupId/${groupId}`;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateContactListDocument = async (file: any, groupId: any) => {
  try {
    const url = `${urls.UPDATE_CONTACT_GROUP}/${groupId}/new`;
    const callParams = await getFileCallParams("POST", file);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getContactsCountBySegmentId = async (
  segmentId: number,
  segmentTypeId: number,
  searchText: string
) => {
  try {
    const url = `${urls.GET_CONTACTS_COUNT_BY_SEGMENT_ID}/${segmentId}/new`;
    const body = {
      searchText: searchText,
      filterType: "",
      segmentTypeId: segmentTypeId,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getContactsBySegmentId = async (
  segmentId: number,
  segmentTypeId: number,
  searchText: string,
  page: number,
  rowsPerPage: number
) => {
  try {
    const url = `${urls.GET_CONTACTS_BY_SEGMENT_ID}/${segmentId}/page/${page}/limit/${rowsPerPage}/new`;
    const body = {
      searchText: searchText,
      filterType: "",
      segmentTypeId: segmentTypeId,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getSubordinatesList = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(urls.GET_SUBORDINATES, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
